/* eslint-disable */
export const sharedDeliveryConstants = {
  mapOptions: {
    gestureHandling: 'greedy',
    styles: null,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    fullscreenControl: false,
    zoom: 11,
    width: '100%',
    height: '100%',
    center: { latitude: 4.666276409205595, longitude: -74.0948896916052 },
    commonMarkerWidth: 32,
    commonMarkerHeight: 32,
    extraMarkerWidth: 25,
    extraMarkerHeight: 33.33,
    allyMarkerWidth: 27,
    allyMarkerHeight: 34,
    extraLabelX: 12.45,
    extraLabelY: 14.47,
    extraLabelFontSize: '10px',
    extraLabelColor: '#B7B7B7',
    extraLabelColorActive: '#3f3f3f',
    markerUrl: 'assets/images/icons/markers/marker-',
    markerExtension: '.png',
    markerTypeStore: 'store',
    markerTypeUser: 'user',
    markerTypeExtra: 'extra',
    markerActive: '-active',
    markerAlly: 'ally',
  },
  attemptToConnectToWSLimit: 3,
  orderCancelData: {
    fineC: '1',
    fineR: '1',
    payC: '1',
    payR: '1',
    verificationCode: 'xxxxxxxxxx',
  },
  statusEndFailedText: ['Finalizado Fallido', 'Finalizada Fallido'],
  logs: {
    editType: {
      addRoundTrip: 'Añadir Ida y vuelta',
      removeRoundTrip: 'Eliminar ida y vuelta',
      addAddress: 'Añadir dirección',
      removeAddress: 'Eliminar dirección',
      addTransfer: 'Añadir traslado',
    },
    dataType: {
      int: 0,
      double: 1,
      string: 2,
      boolean: 3,
      map: 4,
      list: 5,
    },
    field: {
      cancelAt: 'cancelAt',
      uuid: 'uuid',
      userId: 'userId',
      statusId: 'status',
      updatedAt: 'updatedAt',
      username: 'username',
      companyName: 'client',
      pointName: 'store',
      typeEdit: 'typeEdit',
      stopsAdded: 'stopsAdded',
      stopsRemoved: 'stopsRemoved',
      countDuplicateOrder: 'countDuplicateOrder',
      transfer: 'transfer',
      kmsInit: 'kmsInit',
      kmsNew: 'kmsNew',
      priceInit: 'priceInit',
      priceNew: 'priceNew',
      roundTripAdded: 'roundTripAdded',
      roundTripRemoved: 'roundTripRemoved',
      createdAt: 'createdAt',
      totalService: 'totalService',
      currency: 'currency',
      isDuplicated: 'isDuplicated',
    },
  },
  statusList: {
    created: 1,
    waiting: 2,
    assigned: 3,
    inProcess: 4,
    end: 5,
    canceled: 6,
    endFailed: 8,
  },
};
